import React from 'react';
import styled from 'styled-components';

const TitleBackground = styled.div`
  padding: 43px 0 16px;
  background-color: ${({ theme }) => theme.titleBarBackgroundColor};
  margin-bottom: 32px;
  min-height: 92px;
`;

const Title = styled.div`
  color: ${({ theme }) => theme.titleBarColor};
  font-family: Inter;
  font-size: 22px;
  font-style: normal;
  font-weight: 700;
  line-height: 30.8px;
`;

const TitleBar: React.FC = () => {
  return (
    <TitleBackground>
      <div className='container'>
        <Title>Find your game</Title>
      </div>
    </TitleBackground>
  );
};

export default TitleBar;
